import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Comment recevoir mes billets ?",
    a: "Vos billets vous sont envoyés par e-mail au format e-ticket immédiatement après le paiement. Présentez-les en version imprimée ou directement sur votre smartphone à l'entrée de la salle.",
  },
  {
    q: "Le paiement est-il sécurisé ?",
    a: "Oui. Tous les paiements sont traités par Whop, plateforme reconnue pour la sécurité des transactions. Vos données bancaires ne sont jamais stockées sur nos serveurs.",
  },
  {
    q: "Quelle est la différence entre Carré Or, Catégorie 1, 2 et 3 ?",
    a: "Carré Or désigne les places les plus proches de la scène avec une visibilité optimale. Les catégories 1, 2 et 3 correspondent à un éloignement progressif de la scène, à des tarifs adaptés.",
  },
  {
    q: "Puis-je annuler ou échanger mes billets ?",
    a: "Conformément à l'article L221-28 du Code de la consommation, les billets de spectacle ne sont ni remboursables, ni échangeables, sauf en cas d'annulation officielle de l'événement.",
  },
  {
    q: "Combien de billets puis-je acheter ?",
    a: "Vous pouvez acheter jusqu'à 10 billets par commande et par concert.",
  },
  {
    q: "Quand les billets pour les autres concerts seront-ils disponibles ?",
    a: "Les ventes pour Damso, Drake, Iron Maiden et les autres événements ouvriront prochainement. Inscrivez-vous à la newsletter pour être prévenu en avant-première.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32" data-testid="faq-section">
      <div className="mb-12">
        <p className="overline">Questions fréquentes</p>
        <h2 className="text-4xl md:text-5xl font-black tracking-tighter mt-3">
          Tout ce qu'il faut savoir
          <span className="text-primary">.</span>
        </h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
            <AccordionTrigger className="text-left hover:text-primary hover:no-underline" data-testid={`faq-q-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
